/**
 * Focuses an element by its data-attribute and scrolls it into view.
 * This ensures the element is visible and not hidden behind fixed navigation bars.
 *
 * @param dotNotation - The dot notation path of the field (e.g., "address.postalcode")
 */
export const focusElement = (dotNotation: string) => {
  const element = document.querySelector(`[data-attribute="${dotNotation}"]`) as HTMLElement;

  if (!element) return;

  const focusableChild = element.hasAttribute('tabindex')
    ? element
    : (element.querySelector(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="radiogroup"] label',
      ) as HTMLElement) || element;

  // Scroll into view before focusing to ensure element is not hidden behind navigation bar
  focusableChild?.scrollIntoView({
    behavior: 'auto',
    block: 'center',
    inline: 'nearest',
  });

  focusableChild?.focus();
};
